import styled from '@emotion/styled';

export const ButtonsContainer = styled('div', { label: 'ButtonsContainer' })`
    display: flex;
    flex-wrap: wrap;

`;

export const ButtonWrapper = styled('button', { label: 'ButtonWrapper' })`
    background: transparent;
    border: 1px solid #ccc;
    border-radius: 3px;
    color: #888;
    cursor: pointer;
    flex: 1 0 15%;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 4px;
    padding: 4px;
    vertical-align: middle;

    &:not(:last-of-type) {
        margin-right: 4px;
    }
`;
